import React from 'react';

const variants = {
  primary: 'sp-button sp-button--primary',
  secondary: 'sp-button sp-button--secondary',
  danger: 'sp-button sp-button--danger',
  ghost: 'sp-button sp-button--ghost',
  outline: 'sp-button sp-button--secondary'
};

const sizes = {
  sm: 'text-[13px]',
  md: 'text-[13px]',
  lg: 'text-[14px]'
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 ${variants[variant] || variants.primary} ${
        sizes[size] || sizes.md
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
